import { useTranslation } from 'react-i18next'
import { motion } from 'framer-motion'
import ApplyForm from '../../components/apply/ApplyForm'
import { fadeInUp } from '../../utils/animations'

export default function ApplyPage() {
  const { t } = useTranslation()

  return (
    <article className="header-offset">
      <div className="relative overflow-hidden gradient-brand py-16 text-white">
        <div className="absolute inset-0 opacity-20">
          <div className="absolute -end-20 top-0 h-64 w-64 rounded-full bg-accent blur-3xl" />
        </div>
        <div className="relative mx-auto max-w-4xl px-4 text-center sm:px-6">
          <motion.p
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="mb-3 text-sm font-semibold uppercase tracking-widest text-accent"
          >
            {t('apply.label')}
          </motion.p>
          <motion.h1
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="text-4xl font-bold sm:text-5xl"
          >
            {t('apply.title')}
          </motion.h1>
          <motion.p
            initial="hidden"
            animate="visible"
            variants={fadeInUp}
            className="mx-auto mt-4 max-w-2xl text-lg text-white/80"
          >
            {t('apply.subtitle')}
          </motion.p>
        </div>
      </div>

      <div className="section-padding">
        <div className="mx-auto max-w-7xl">
          <ApplyForm />
        </div>
      </div>
    </article>
  )
}
